import { Component,AfterViewInit, OnInit , ViewChild, ElementRef } from '@angular/core';
import { UserService } from "../services/user/user.service";
import { CartService } from "../services/cart/cart.service";
// import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import {Chart} from 'chart.js';
@Component({
  selector: 'app-b2b',
  templateUrl: './b2b.component.html',
  styleUrls: ['./b2b.component.css']
})
export class B2bComponent implements OnInit {

  mouvement:any;
  balanceData=[];
  caData=[];
  caLabels=[];
  now = new Date()
  allMonth = [
    'nan',
    'Jan',
    'Fév',
    'Mars',
    'Avr',
    'Mai',
    'Jui',
    'Juil',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc'
  ]
  @ViewChild('balance') balancesAge: ElementRef;
  @ViewChild('ca') chartCa: ElementRef;
  constructor(private userService:UserService,private cartService:CartService) {

    this.userService.statistics().subscribe(res =>{
      this.mouvement = res["mouvement"];

      for (let i = 1; i <= 5; i++) {
        this.balanceData.push(res["balance"]["facture"]["g"+i]);
      }

      var curentMonth = this.now.getMonth()+1;
      var startMonth = this.now.getMonth()+2;
      var tempMonth = startMonth;
      var curentYear = this.now.getFullYear()-1;

      for (let i = 0; i < 11; i++) {
        var test = res["CA"].filter(ele => ele.MM == Math.abs(tempMonth))
        if (tempMonth==12) {
          tempMonth=0;
          curentYear++;
        }

        if (test.length!=0) {
          this.caData.push(test[0].CA);
        }else{
          this.caData.push(0);
        }

        this.caLabels.push(this.allMonth[tempMonth]+" "+curentYear);

        tempMonth++;
      }


    },error => console.log('oops', error.status))



  }

  ngOnInit():void
  {
    setTimeout(() => {

      var d = new Date();
      var currentMont = d.getMonth()
      d.setMonth(d.getMonth() - 1)
      var currentMontPlus1 = d.getMonth()
      var d = new Date();
      d.setMonth(d.getMonth() - 2)
      var currentMontPlus2 = d.getMonth()
      var d = new Date();
      d.setMonth(d.getMonth() - 3)
      var currentMontPlus3 = d.getMonth()
      var month = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Décembre'];
      
      const labels = [
        '+90 j',
        month[currentMontPlus3],
        month[currentMontPlus2],
        month[currentMontPlus1],
        month[currentMont],
      ];

      const data = {
        labels: labels,
        datasets: [{
        label: 'Total',
        backgroundColor: '#c80217',
        borderColor: '#000',
        data: this.balanceData.reverse(),
        }]
      }

      const config = {
        type: "bar",
        data: data,
      }
      const chart1 = new Chart(
      this.balancesAge.nativeElement,{type: "bar",data: data} );


      const dataCa = {
        labels: this.caLabels,
        datasets: [{
        label: 'Total',
        backgroundColor: '#eae974',
        borderColor: '#000',
        data: this.caData,
        }]
      }

      const chart2 = new Chart(
      this.chartCa.nativeElement,{type: "bar",data: dataCa} );
    }, 3000);

  }



  testMe()
  {
    this.cartService.getCart().subscribe(res =>{
      
    })
  }

}
